{
  "//vg-binding": "CONTEXT:decisions=P6.1.D-28,P6.1.D-20 | INTERFACE-STANDARDS:error-shape",
  "page": {
    "title": "Team",
    "subtitle": "Nhóm các cửa hàng thành team — mỗi team chỉ thấy dữ liệu và ngân sách của riêng mình"
  },
  "actions": {
    "create": "Tạo team",
    "edit": "Chỉnh sửa",
    "deactivate": "Ngừng hoạt động team"
  },
  "col": {
    "team": "Team",
    "stores": "Cửa hàng",
    "members": "Thành viên",
    "spending": "Chi tiêu",
    "status": "Trạng thái",
    "actions": "Thao tác"
  },
  "cell": {
    "stores": "{{count}} cửa hàng",
    "storesOne": "{{count}} cửa hàng"
  },
  "status": {
    "Active": "Đang hoạt động",
    "Inactive": "Ngừng hoạt động"
  },
  "menu": {
    "edit": "Chỉnh sửa",
    "deactivate": "Ngừng hoạt động team"
  },
  "unassigned": {
    "count": "{{count}} cửa hàng chưa được gán vào team nào",
    "countOne": "{{count}} cửa hàng chưa được gán vào team nào",
    "hint": "Chỉ bạn và quản trị viên mới thấy được dữ liệu của chúng cho tới khi được gán",
    "assign": "Gán vào team"
  },
  "form": {
    "createTitle": "Tạo team",
    "editTitle": "Chỉnh sửa team",
    "name": "Tên team",
    "namePlaceholder": "ví dụ: US Market",
    "nameRequired": "Nhập tên team",
    "stores": "Cửa hàng",
    "storesPlaceholder": "Gán ít nhất một cửa hàng",
    "storesHint": "Gán ít nhất một cửa hàng",
    "storesRequired": "Chọn ít nhất một cửa hàng",
    "teamLead": "Trưởng nhóm",
    "teamLeadPlaceholder": "Chọn trưởng nhóm",
    "leadRequired": "Chọn trưởng nhóm",
    "spendingLimit": "Hạn mức chi tiêu",
    "spendingLimitHint": "Để trống nếu không giới hạn",
    "save": "Lưu",
    "saving": "Đang lưu..."
  },
  "confirm": {
    "deactivate": {
      "title": "Ngừng hoạt động team này?",
      "body": "Tất cả cửa hàng sẽ được trả về Chưa gán và thành viên chuyển sang không có team. Bạn có thể khôi phục bằng cách gán lại sau.",
      "confirm": "Ngừng hoạt động team",
      "cancel": "Huỷ"
    }
  },
  "toast": {
    "created": "Đã tạo team",
    "updated": "Đã cập nhật team",
    "deactivated": "Đã ngừng hoạt động team",
    "storesAssigned": "Đã gán cửa hàng",
    "createFailed": "Không thể tạo team",
    "updateFailed": "Không thể cập nhật team",
    "deactivateFailed": "Không thể ngừng hoạt động team",
    "duplicateName": "Đã tồn tại một team trùng tên"
  },
  "empty": {
    "title": "Chưa có team nào",
    "subtitle": "Tạo một team để nhóm các cửa hàng và kiểm soát quyền truy cập cùng ngân sách.",
    "cta": "Tạo team đầu tiên"
  },
  "error": {
    "loadFailed": "Không thể tải danh sách team.",
    "retry": "Thử lại",
    "forbidden": {
      "title": "Từ chối truy cập",
      "body": "Bạn không có quyền quản lý team. Vui lòng liên hệ chủ shop."
    }
  },
  "breadcrumb": {
    "settings": "Cài đặt",
    "teams": "Team"
  },
  "scopeChanged": "Quyền truy cập store đã thay đổi — đang làm mới",
  "filter": {
    "searchPlaceholder": "Tìm nhóm",
    "status": "Trạng thái",
    "statusAll": "Tất cả trạng thái",
    "sort": "Sắp xếp"
  },
  "sort": {
    "nameAsc": "Tên (A–Z)",
    "nameDesc": "Tên (Z–A)",
    "spendDesc": "Chi tiêu cao nhất",
    "newest": "Mới nhất"
  }
}
